export default "__VITE_ASSET__DfHWMwlN__"